export const BLOCK_TYPE_FAQ_LIST_AREA = 'faq-list-area';
